import React from "react";
import { AuthProvider } from "./contexts/AuthContext";
import AuthGate from "./components/AuthGate";
import Routes from "./Routes";

function App() {
  return (
    <AuthProvider>
      <AuthGate>
        {/* Bloque normal, no flex-col: sin la banda ya no hay nada que apilar, y
            como ítem de un flex en columna cada página tomaba el ancho mínimo
            de su encabezado (en 375 px el Historial se salía 14 px a la derecha). */}
        <div className="min-h-screen">
          <Routes />
        </div>
      </AuthGate>
    </AuthProvider>
  );
}

export default App;
